<template>
    <div class="content flex-sub wrapper flex padding-lr-sm">
        <div class="flex flex-direction flex-sub bg-white">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form" labelWidth="auto">
                <el-form-item ref="title" label="议题" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请输入" :disabled="readonly">
                    </el-input>
                </el-form-item>
                <el-form-item ref="meeting_time" label="时间" prop="meeting_time">
                    <el-date-picker
                        v-model="ruleForm.meeting_time"
                        placeholder="选择日期"
                        type="date"
                        value-format="yyyy-MM-dd" :disabled="readonly">
                    </el-date-picker>
                </el-form-item>
                <el-form-item ref="address" label="地点" prop="address">
                    <el-input v-model="ruleForm.address" placeholder="请输入" :disabled="readonly">
                    </el-input>
                </el-form-item>
                <el-form-item ref="meeting_file" label="会议材料" prop="meeting_file">
                   <upload-file type="file" :files="ruleForm.meeting_file" multiple @uploadFile="uploadFile" :disabled="readonly"></upload-file>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item ref="ought_num" label="应到数" prop="ought_num">
                    <el-input-number v-model="ruleForm.ought_num" placeholder="请输入" :step="1" step-strictly :controls="false">
                    </el-input-number>
                </el-form-item>
                <el-form-item ref="solid_num" label="实到数" prop="solid_num">
                    <el-input-number v-model="ruleForm.solid_num" placeholder="请输入" :step="1" step-strictly :controls="false">
                    </el-input-number>
                </el-form-item>
                <el-form-item ref="absent_num" label="缺席数" prop="absent_num">
                    <el-input-number v-model="ruleForm.absent_num" placeholder="请输入" :step="1" step-strictly :controls="false">
                    </el-input-number>
                </el-form-item>
                <el-form-item ref="absent_remark" label="缺席原因" prop="absent_remark" v-if="ruleForm.absent_num">
                    <el-input v-model="ruleForm.absent_remark" placeholder="请输入">
                    </el-input>
                </el-form-item>
                <el-form-item ref="speak_remark" label="发言要点" prop="speak_remark">
                    <el-input v-model="ruleForm.speak_remark" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
                <el-form-item ref="opinion" label="不同意见" prop="opinion">
                    <el-input v-model="ruleForm.opinion" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
                <el-form-item ref="vote_table" label="表决表" prop="vote_table">
                    <upload-file type="file" :files="ruleForm.vote_table" multiple @uploadFile="uploadFile"></upload-file>
                </el-form-item>
                <el-form-item ref="meeting_remark" label="大会决议" prop="meeting_remark">
                    <el-input v-model="ruleForm.meeting_remark" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="flex align-center justify-end margin-top">
<!--                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm',1)" v-if="status === 1">保存-->
<!--                </el-button>-->
                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm',2)">发布
                </el-button>
            </div>
        </div>
        <div class="templates flex flex-direction margin-left-sm padding-sm" v-if="templates.length">
            <div class="text-bold text-black text-lg">模版</div>
            <div class="template flex flex-direction margin-top-sm bg-gray" v-for="(item,index) in templates" :key="index">
                <div class="text-df text-black padding-sm">{{item.title}}</div>
                <div class="operate flex align-center">
                    <el-link :underline="false" class="flex-sub text-red" type="text" :href="BASE_URL + item.meeting_url">查看</el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-link :underline="false" class="flex-sub text-red" type="text" :href="BASE_URL + item.meeting_url">下载</el-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {confirm, TOAST, toast} from "@/utils/utils";
import {addMeetingProcedure, getMeetingDetail, getMeetingTemplates} from "@/api";
import UploadFile from "@/views/web/components/UploadFile";
import {BASE_URL} from "@/config";

export default {
    name: "MeetingProcedure",
    components: {UploadFile},
    data() {
        return {
            BASE_URL:BASE_URL,
            ruleForm: {
                title: '',
                meeting_time: '',
                address: '',
                meeting_file: [],

                ought_num:0,
                solid_num:0,
                absent_num:0,
                absent_remark:'',
                speak_remark:'',
                opinion:'',
                vote_table:[],
                meeting_remark:'',
            },
            rules: {
                ought_num: [
                    {required: true, message: '请输入应到数', trigger: 'change'},
                ],
                solid_num: [
                    {required: true, message: '请输入实到数', trigger: 'change'},
                ],
                absent_num: [
                    {required: true, message: '请输入缺席数', trigger: 'change'},
                ],
                absent_remark: [
                    {required: true, message: '请输入缺席原因', trigger: 'change'},
                ],
                speak_remark: [
                    {required: true, message: '请输入发言要点', trigger: 'change'},
                ],
            },
            templates:[],
            loading: false,
            readonly:true,
            status:1
        }
    },
    props: {
        type: {//1党员大会 2 委员会
            type: Number,
            default: 1
        },
        aid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.aid) this.init()
        // this.getMeetingTemplates()
    },
    methods: {
        async getMeetingTemplates() {
            let _data = await getMeetingTemplates()
            this.templates = _data.data
        },
        async init() {
            let _data = await getMeetingDetail(this.aid)
            this.ruleForm.title = _data.data.title
            this.ruleForm.meeting_time = _data.data.meeting_time
            this.ruleForm.address = _data.data.address
            this.ruleForm.meeting_file = _data.data.meeting_file

            this.ruleForm.ought_num = _data.data.ought_num || 0
            this.ruleForm.solid_num = _data.data.solid_num || 0
            this.ruleForm.absent_num = _data.data.absent_num || 0
            this.ruleForm.absent_remark = _data.data.absent_remark
            this.ruleForm.speak_remark = _data.data.speak_remark
            this.ruleForm.opinion = _data.data.opinion
            this.ruleForm.vote_table = _data.data.vote_table ? JSON.parse(_data.data.vote_table) : []
            this.ruleForm.meeting_remark = _data.data.meeting_remark
            this.status = _data.data.status

        },
        uploadFile(data){
            if (data) {
                this.ruleForm.vote_table = data.files
            }
        },
        watchEditor(data) {
            this.ruleForm.content = data
        },
        submitForm(formName,is_storage) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem(is_storage);
                }
            });
        },
        async addItem(is_storage) {
            this.loading = true
            let _data = await addMeetingProcedure(this.aid,this.ruleForm.ought_num,this.ruleForm.solid_num,this.ruleForm.absent_num,
                    this.ruleForm.absent_remark,this.ruleForm.speak_remark,this.ruleForm.opinion,
                JSON.stringify(this.ruleForm.vote_table),this.ruleForm.meeting_remark,is_storage)
            this.loading = false
            if (_data.status === 200) {
                // toast('保存成功', TOAST.success)
                if (is_storage === 2){
                    confirm(`保存成功`, `是否进行下一步信息填写？`, () => {
                        this.$emit('watchNext', this.aid,true)
                    }, '确认', true,()=>{
                        this.$emit('watchNext', this.aid,false)
                    })

                }
            } else {
                toast(_data.msg, TOAST.error)
            }
        }
    },
    filters: {

    },
    watch: {
        aid() {
            if (this.aid) {
                this.init();
            } else {
                this.$refs.ruleForm.resetFields()
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    .choose-model {
        position: absolute;
        bottom: 200px;
        right: 30px;
    }
    .templates{
        width: 300px;
        border: 1px solid #eeeeee;
        .operate{
            height: 50px;
        }
    }
}
</style>